module.exports = __webpack_public_path__ + "img/catabocata2.cf5b0aec.png";